'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Middleware = require('./Middleware');

var _Middleware2 = _interopRequireDefault(_Middleware);

var _defaults = require('./defaults');

var _defaults2 = _interopRequireDefault(_defaults);

var _arms = require('./middlewares/arms');

var _arms2 = _interopRequireDefault(_arms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var middleware = new _Middleware2.default();

function request(params) {
    var ctx = {
        req: {},
        res: {}
    };

    var targetParams = Object.assign({}, request.defaults, params);
    targetParams.headers = Object.assign({}, request.defaults.headers, params.headers);

    ctx.req.params = targetParams;

    var promise = middleware.run(ctx);

    return promise.then(function () {
        return ctx.res.data;
    });
}

request.use = function (fn) {
    middleware.use(fn);
};

// 开启错误上报
request.use(_arms2.default);

request.defaults = _defaults2.default;

exports.default = request;